import React, {useState, useEffect, useRef} from 'react';

import { Container } from './styles';

export type QueryBuilderProps = {
  title: string;
  color?: string;
  className?: string;
  contents: React.ReactNode[];
}

export const QueryBuilder = ({title, contents, className, color = "#596778"}: QueryBuilderProps) => {

  const lastChildRef = useRef(null);
  const [lastChildHeight, setLastChildHeight] = useState(0);
  
  useEffect(() => {
    if (lastChildRef.current) {
      setLastChildHeight(lastChildRef.current.offsetHeight)
    }
  
  }, [lastChildRef.current])

  return <Container className={className} color={color} lastChildHeight={lastChildHeight / 2}>
    <p>{title}</p>
    {contents?.length > 0 && contents.map((content, index) => {
      if (index === contents.length - 1) {
        return <div key={Math.random()} className="card" ref={lastChildRef}>
          {content}
        </div>
      } else {
        return <div key={Math.random()} className="card">
          {content}
        </div> 
      }
    }
      
    )}

  </Container>;
}